export function getContainerVisibility(el, container) {
  var _el$getBoundingClient = el.getBoundingClientRect(),
    height = _el$getBoundingClient.height,
    top = _el$getBoundingClient.top;
  var current = window.innerHeight - top;
  var max = window.innerHeight + height;
  var localScroll = Math.max(window.scrollY - (container instanceof Window ? 0 : container.offsetTop), 0);
  return container instanceof Window ? current / max : localScroll / container.offsetHeight;
}
export function getContainerCursorPosition(container, cursorX, cursorY) {
  var _container$getBoundin = container.getBoundingClientRect(),
    height = _container$getBoundin.height,
    left = _container$getBoundin.left,
    top = _container$getBoundin.top,
    width = _container$getBoundin.width;
  var x = (cursorX - left) / width;
  var y = (cursorY - top) / height;
  return {
    x: x,
    y: y
  };
}